import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <h1 className="Header">
        MidDay
    </h1>
  )
}

export default Header